<template>
	<a @click="editLink" class="edit-link-btn">
		<g class="clickable-group" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave">
			<path :d="dAttr" :style="pathStyle"></path>

			<g v-if="show.edit" :transform="pencilTransform">
				<circle cx="16" cy="16" r="16" style="fill:white;stroke:#ff8855;stroke-width:1;"/>
				<image xlink:href="../assets/trash-can-outline.svg" x="6" y="5" height="20px" width="20px"/>
			</g>
		</g>
	</a>
</template>

<script>
	export default {
		name: 'ExperienceLink',
		props: {
			// start point position [x, y]
			start: {
				type: Array,
				default() {
					return [0, 0]
				}
			},
			// end point position [x, y]
			end: {
				type: Array,
				default() {
					return [0, 0]
				}
			},
			id: Number,
		},
		data() {
			return {
				show: {
					edit: false,
				}
			}
		},
		methods: {
			handleMouseOver() {
				if (this.id) {
					this.show.edit = true;
				}
			},
			handleMouseLeave() {
				this.show.edit = false;
			},
			calculateCenterPoint() {
				// caculate arrow position: the center point between start and end
				const dx = (this.end[0] - this.start[0]) / 2;
				const dy = (this.end[1] - this.start[1]) / 2;
				return [this.start[0] + dx, this.start[1] + dy];
			},
			// calculateRotation() {
			// 	// caculate arrow rotation
			// 	const angle = -Math.atan2(this.end[0] - this.start[0], this.end[1] - this.start[1]);
			// 	const degree = angle * 180 / Math.PI;
			// 	return degree < 0 ? degree + 360 : degree;
			// },
			editLink() {
				this.$emit('editLink')
			}
		},
		computed: {
			pathStyle() {
				return {
					stroke: 'rgb(255, 136, 85)',
					strokeWidth: 2.73205,
					fill: 'transparent',
				}
			},
			// arrowStyle() {
			// 	return {
			// 		stroke: 'rgb(255, 136, 85)',
			// 		strokeWidth: 5.73205,
			// 		fill: 'none',
			// 	}
			// },
			// arrowTransform() {
			// 	const [arrowX, arrowY] = this.calculateCenterPoint();
			// 	const degree = this.calculateRotation();
			// 	return `translate(${arrowX}, ${arrowY}) rotate(${degree})`;
			// },
			pencilTransform() {
				const [arrowX, arrowY] = this.calculateCenterPoint();
				// console.log([arrowX, arrowY])
				return `translate(${arrowX-16}, ${arrowY-16})`;
			},
			dAttr() {
				let cx = this.start[0], cy = this.start[1], ex = this.end[0], ey = this.end[1];
				let x1 = cx, y1 = cy + 50, x2 = ex, y2 = ey - 50;
				return `M ${cx}, ${cy} C ${x1}, ${y1}, ${x2}, ${y2}, ${ex}, ${ey}`;
			}
		}
	}
</script>

<style scoped lang="scss">
	$themeColor: rgb(255, 136, 85);

	.clickable-group {
		pointer-events: bounding-box;
		cursor: pointer;
		fill: transparent;
	}

	.custom-class {
		width: 12px;
		height: 12px;
	}

	.edit-link-btn svg {
		background-color: #fff;
		border: 1px solid $themeColor;
			border-radius: 100px;
			text-align: center;
			&:hover{
				background: $themeColor;
				color: white;
			}
	}
</style>